import './logo.css';
import { useBranding } from '#/branding/BrandingContext';

const handleLogoClick = () => {
  const elem = document.documentElement; // or any specific container

  if (elem.requestFullscreen) {
    elem.requestFullscreen();
  } else if ((elem as any).webkitRequestFullscreen) { // Safari
    (elem as any).webkitRequestFullscreen();
  } else if ((elem as any).msRequestFullscreen) { // IE11
    (elem as any).msRequestFullscreen();
  }
};

const Logo: React.FC = () => {
  const { logo } = useBranding();
  return (
    <div className="logo-container" onClick={handleLogoClick}>
      <img src={logo} id="logo" />
    </div>
  );
};

export default Logo;
